/**
 * Client-side mirror of the server's `wantsHumanAgent` regex
 * (`packages/ai/src/rag/chat-orchestrator.ts`). The server is the source
 * of truth for the handoff decision, but the widget also runs this check
 * defensively: if the server's `needsHumanHandoff` flag is missing (stale
 * server build, network quirk, misbehaving provider that drops the JSON
 * envelope) and the user clearly asked for a human, we still trigger the
 * handoff flow instead of leaving the user stuck with an unhelpful AI
 * refusal ("no puedo conectar con un agente…").
 *
 * Keep this in sync with `HUMAN_REQUEST_RE` on the server. We do NOT
 * import from the `@helpdesk/ai` package because the widget is a
 * shadow-DOM bundle that must not pull in server-only deps.
 */
const HUMAN_REQUEST_RE =
  /\b(agente|asesor|humano|humana|persona\s+real|representante|operador|ejecutivo|human|real\s+person|live\s+agent|real\s+agent|speak\s+to\s+(?:an?\s+)?human|talk\s+to\s+(?:an?\s+)?human|habla(?:r|me)?\s+con\s+(?:un(?:a)?\s+)?(?:humano|humana|agente|asesor|persona|operador|ejecutivo)|pasa(?:me|rme)?\s+(?:con|a)\s+(?:un(?:a)?\s+)?(?:humano|humana|agente|asesor|persona|operador|ejecutivo)|pase(?:me|nme)?\s+(?:con|a)\s+(?:un(?:a)?\s+)?(?:humano|humana|agente|asesor|persona|operador|ejecutivo)|quiero\s+(?:hablar\s+con\s+)?(?:un(?:a)?\s+)?(?:humano|humana|agente|asesor|persona|operador|ejecutivo)|conectame\s+con|contactarme?\s+con\s+(?:un(?:a)?\s+)?(?:humano|humana|agente|asesor))\b/i;

export function wantsHumanAgent(message: string): boolean {
  return HUMAN_REQUEST_RE.test(message);
}
